const NullCheck = ({ children, valueForCheck }) => {
  return valueForCheck ? children : null;
};
export default NullCheck;
